<template>
  <div class="register-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      custom-class="login"
    >
      <div class="register-wrapper flex-start">
        <div class="left-content">
          <img src="../../../../assets/home/register.webp" alt="注册背景图" />
        </div>
        <div class="right-content">
          <h3>注册</h3>

          <div class="menu-wrapper space-between">
            <span
              class="menu-item email"
              :class="currentIndex === 0 ? 'menu-item-active' : ''"
              @click="handleSwitch('EMAIL', 0)"
            >
              通过电子邮箱注册
            </span>
            <span
              class="menu-item phone"
              :class="currentIndex === 1 ? 'menu-item-active' : ''"
              @click="handleSwitch('SHORT_MSG', 1)"
            >
              通过手机号码注册
            </span>
          </div>

          <div class="form-wrapper">
            <el-form
              ref="emailForm"
              :model="emailRegisterForm"
              :rules="emailRegisterRules"
              class="register-form"
              autocomplete="off"
              label-position="left"
              v-show="currentIndex === 0"
            >
              <el-form-item prop="account">
                <el-input
                  ref="account"
                  v-model="emailRegisterForm.account"
                  placeholder="请设置账号名称"
                  name="account"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>

              <el-form-item prop="email">
                <el-input
                  ref="email"
                  v-model="emailRegisterForm.email"
                  placeholder="请输入电子邮箱"
                  name="email"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>

              <el-form-item class="drag-item">
                <drag-verify
                  key="1"
                  ref="dragVerify1"
                  :width="440"
                  :height="45"
                  text="请按住滑块，拖动到最右边"
                  success-text="验证成功"
                  :is-passing.sync="emailIsPassing"
                  handler-icon="el-icon-d-arrow-right"
                  success-icon="el-icon-circle-check"
                />
              </el-form-item>

              <el-form-item prop="code">
                <el-row class="code-row">
                  <el-col :span="16">
                    <el-input
                      ref="code"
                      v-model="emailRegisterForm.code"
                      placeholder="请输入电子邮箱验证码"
                      name="email"
                      type="text"
                    />
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      v-if="emailIsPassing"
                      class="sendCodeBtn"
                      plain
                      :disabled="totalTime < 60"
                      @click="getCountdown('email')"
                    >
                      {{ content }}
                    </el-button>
                    <el-button v-else disabled class="sendCodeBtn" plain>获取验证码</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  ref="password"
                  v-model="emailRegisterForm.password"
                  :type="passwordType"
                  placeholder="请输入密码"
                  name="password"
                  autocomplete="off"
                />
                <span class="show-pwd" @click="showPwd">
                  <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                </span>
              </el-form-item>

              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%; margin-bottom: 10px"
                @click.native.prevent="handleRegister"
              >
                立即注册
              </el-button>

              <div class="tips" @click="openLogin">已有账号，去登录</div>
            </el-form>
            <el-form
              ref="phoneForm"
              :model="phoneRegisterForm"
              :rules="phoneRegisterRules"
              class="register-form"
              autocomplete="off"
              label-position="left"
              v-show="currentIndex === 1"
            >
              <el-form-item prop="account">
                <el-input
                  ref="account"
                  v-model="phoneRegisterForm.account"
                  placeholder="请设置账号名称"
                  name="account"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>

              <el-form-item prop="phone">
                <el-input
                  ref="phone"
                  v-model="phoneRegisterForm.phone"
                  placeholder="请输入手机号码"
                  name="phone"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>

              <el-form-item class="drag-item">
                <drag-verify
                  key="2"
                  ref="dragVerify2"
                  :width="440"
                  :height="45"
                  text="请按住滑块，拖动到最右边"
                  success-text="验证成功"
                  :is-passing.sync="phoneIsPassing"
                  handler-icon="el-icon-d-arrow-right"
                  success-icon="el-icon-circle-check"
                />
              </el-form-item>

              <el-form-item prop="code">
                <el-row class="code-row">
                  <el-col :span="16">
                    <el-input
                      ref="code"
                      v-model="phoneRegisterForm.code"
                      placeholder="请输入手机验证码"
                      name="email"
                      type="text"
                    />
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      v-if="phoneIsPassing"
                      class="sendCodeBtn"
                      plain
                      :disabled="totalTime < 60"
                      @click="getCountdown('phone')"
                    >
                      {{ content }}
                    </el-button>
                    <el-button v-else disabled class="sendCodeBtn" plain>获取验证码</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  ref="password"
                  v-model="phoneRegisterForm.password"
                  :type="passwordType"
                  placeholder="请输入密码"
                  name="password"
                  autocomplete="off"
                />
                <span class="show-pwd" @click="showPwd">
                  <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                </span>
              </el-form-item>

              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%; margin-bottom: 10px"
                @click.native.prevent="handleRegister"
              >
                立即注册
              </el-button>

              <div class="tips" @click="openLogin">已有账号，去登录</div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import dragVerify from '@/components/dragVerfy.vue';
import { validateAccount, validateEMail, validatePsdReg, validatePhone } from '@/utils/validate';
import event from '@/utils/event';
export default {
  inject: ['reload'],
  data() {
    return {
      dialogVisible: false,
      phoneIsPassing: false,
      emailIsPassing: false,
      emailRegisterForm: {
        account: '',
        email: '',
        password: '',
        code: '',
      },
      phoneRegisterForm: {
        account: '',
        phone: '',
        password: '',
        code: '',
      },
      paramData: {
        account: '',
        notificationObj: '',
        notificationMode: '',
        password: '',
        code: '',
      },
      emailRegisterRules: {
        account: [{ required: true, trigger: 'blur', validator: validateAccount }],
        email: [{ required: true, trigger: 'blur', validator: validateEMail }],
        password: [{ required: true, trigger: 'blur', validator: validatePsdReg }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      phoneRegisterRules: {
        account: [{ required: true, trigger: 'blur', validator: validateAccount }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
        password: [{ required: true, trigger: 'blur', validator: validatePsdReg }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      loading: false,
      passwordType: 'password',
      totalTime: 60,
      content: '获取验证码',
      isSend: true,
      currentIndex: 0,
      tabName: 'EMAIL',
    };
  },
  methods: {
    ...mapActions(['register', 'getAuthCode']),
    open() {
      this.dialogVisible = true;
    },
    handleSwitch(tabName, index) {
      this.tabName = tabName;
      this.paramData.notificationMode = tabName;
      this.currentIndex = index;

      // 清除验证信息
      this.$refs['phoneForm'].clearValidate();
      this.$refs['emailForm'].clearValidate();

      window.clearInterval(this.clock);
      this.content = '获取验证码';
      this.isSend = true;
      this.totalTime = 60;
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    getCountdown(val) {
      const clock = window.setInterval(() => {
        this.content = this.totalTime + 's后重新发送';
        this.totalTime--;
        this.isSend = false;
        if (this.totalTime < 0) {
          this.totalTime = 60;
          this.content = '获取验证码';
          this.isSend = true;
          window.clearInterval(clock);
        }
      }, 1000);
      if (this.isSend) {
        this.getCode(val);
      }
    },

    // 注册账号
    handleRegister() {
      if (this.tabName === 'EMAIL') {
        this.$refs.emailForm.validate(async (valid) => {
          if (valid) {
            this.loading = true;
            this.paramData.account = this.emailRegisterForm.account;
            this.paramData.notificationMode = this.tabName;
            this.paramData.notificationObj = this.emailRegisterForm.email;
            this.paramData.code = this.emailRegisterForm.code;
            this.paramData.password = this.$md5(this.emailRegisterForm.password);
            try {
              const res = await this.register(this.paramData);
              if (res.code === 0) {
                this.$message({
                  message: '注册成功',
                  type: 'success',
                });
                this.dialogVisible = false;
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$refs.phoneForm.validate(async (valid) => {
          if (valid) {
            this.loading = true;
            this.paramData.account = this.phoneRegisterForm.account;
            this.paramData.notificationMode = this.tabName;
            this.paramData.notificationObj = this.phoneRegisterForm.phone;
            this.paramData.code = this.phoneRegisterForm.code;
            this.paramData.password = this.$md5(this.phoneRegisterForm.password);
            try {
              const res = await this.register(this.paramData);
              if (res.code === 0) {
                this.$message({
                  message: '注册成功',
                  type: 'success',
                });
                this.dialogVisible = false;
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },

    // 获取验证码
    async getCode(type) {
      const paramData = {
        Authorization: '111',
        notificationMode: '',
        notificationObj: '',
      };
      // 邮箱和手机收取验证码
      if (type === 'email') {
        paramData.notificationMode = 'EMAIL';
        paramData.notificationObj = this.emailRegisterForm.email;
      } else {
        paramData.notificationMode = 'SHORT_MSG';
        paramData.notificationObj = this.phoneRegisterForm.phone;
      }

      if (paramData.notificationObj == '') {
        this.$message({
          message: '邮箱或者手机号不能为空',
          type: 'error',
        });
        return false;
      }

      try {
        const res = await this.getAuthCode(paramData);
        if (res.code === 0) {
          this.$message({
            message: '验证码已发送',
            type: 'success',
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 打开登录
    openLogin() {
      this.dialogVisible = false;
      event.$emit('openLogin');
    },
  },
  components: {
    dragVerify,
  },
};
</script>

<style lang="scss" scoped>
.register-dialog {
  &::v-deep {
    .el-dialog__header {
      padding: 0px;
    }
    .el-dialog__body {
      padding: 0px;
    }
    .el-input__inner {
      height: 46px;
      line-height: 46px;
      -webkit-appearance: none;
      border-radius: 0;
      border: 1px solid #e7e7e7;
    }
    .el-button {
      width: 100%;
      height: 46px;
      // line-height: 46px;
      text-align: center;
      border-radius: 0;
      text-align: center;
    }
    .el-button--primary {
      background-color: #4173fb;
      border-radius: 4px;
      outline: none;
      border: none;
      height: 47px;
    }
  }

  .drag-item {
    border: 1px solid #e7e7e7;
  }
  .register-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 654px;
    .left-content {
      width: 380px;
      height: 100%;
      img {
        max-width: 100%;
      }
    }
    .right-content {
      box-sizing: border-box;
      width: 520px;
      height: 100%;
      padding: 30px 40px;
      h3 {
        text-align: center;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 35px;
        margin-bottom: 20px;
      }
      .form-wrapper {
        .register-form {
          width: 100%;
          position: relative;
          overflow: hidden;
          .el-input {
            display: inline-block;
            height: 47px;
            width: 100%;
          }

          .el-form-item {
            margin-bottom: 30px;
          }
          .show-pwd {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 16px;
            color: #999;
            cursor: pointer;
            user-select: none;
          }
          .tips {
            text-align: center;
            font-size: 12px;
            font-weight: 300;
            color: #4173fb;
            line-height: 35px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.menu-wrapper {
  // border-bottom: 1px solid #f3f4f7;
  .menu-item {
    box-sizing: border-box;
    display: inline-block;
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin: 5px 0px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }
  .email {
    border-right: 1px solid #f3f4f7;
  }
}
.menu-item-active {
  color: #4173fb !important;
}
</style>
